// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + chunkId + "." + {"2399":"3eb8c5bd32630b67e2b2","2661":"dd2cb65277e33f2a0ce3","4137":"e37376e252706b59a05c","4438":"517cacbb8c2c756b72cd","4655":"922de29071060a48dbb3","5947":"bf4dba8a788789331774"}[chunkId] + ".css";
};